import { invoke } from '@shared/easyfy.decorators';
import TranslatorService, { TranslationKeys } from '@clientWebServices/translator.service';
import { SnackBar, SnackbarSeverity } from '@clientWebModules/snackbar';
import { MESSAGE_KEYS } from '@clientShared/messageKeys';
import { globalEvent } from '@shared/easyfy.core';

@invoke
export default class MessageService {
  static Instance: MessageService;
  private translator: TranslatorService | undefined;
  constructor() {
    if (MessageService.Instance) return MessageService.Instance;

    this.translator = TranslatorService.getInstance();
    globalEvent({
      type: 'form-success',
      events: [
        {
          event: 'display-snackbar-message',
          callback: this.displaySnackBarMessage,
        },
      ],
    });
  }

  displayDefaultErrorMessage(): void {
    this.displayTranslatedMessage(SnackbarSeverity.error, MESSAGE_KEYS.error);
  }

  displayErrorMessage(key: TranslationKeys): void {
    this.displayTranslatedMessage(SnackbarSeverity.error, key);
  }

  displayDefaultSuccessMessage(): void {
    this.displayTranslatedMessage(SnackbarSeverity.success, MESSAGE_KEYS.success);
  }

  displaySuccessMessage(key: TranslationKeys): void {
    this.displayTranslatedMessage(SnackbarSeverity.success, key);
  }

  displayDefaultLoadingMessage(): void {
    this.displayTranslatedMessage(SnackbarSeverity.warning, MESSAGE_KEYS.loading);
  }

  displayDefaultNoResultsMessage(): void {
    this.displayTranslatedMessage(SnackbarSeverity.warning, MESSAGE_KEYS.noResults);
  }

  displayWarningMessage(key: TranslationKeys): void {
    this.displayTranslatedMessage(SnackbarSeverity.warning, key);
  }

  displaySnackBarMessage = (e: Event) => {
    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    const severityAttr = target.getAttribute('data-snackbar-severity');
    const messageAttr = target.getAttribute('data-snackbar-message');
    const iconAttr = target.getAttribute('data-snackbar-icon');

    const severity = severityAttr ? (Number(severityAttr) as SnackbarSeverity) : SnackbarSeverity.success;
    const message = messageAttr || '';
    const icon = iconAttr || undefined;

    this.displayMessage(severity, message, icon);
  };

  displayMessage(severity: SnackbarSeverity, message: string, icon?: string): void {
    if (message.trim() === '') return;
    SnackBar.appendSnackbar(severity, message, icon);
  }

  private async displayTranslatedMessage(severity: SnackbarSeverity, key: TranslationKeys): Promise<void> {
    if (!key) return console.error('No translation key provided');
    const message = await this.translator?.translate(key);
    if (message) {
      SnackBar.appendSnackbar(severity, message);
    } else {
      console.error(`Translation not found for key: ${key}`);
    }
  }
}
